import { INVOICE_DUE_DATE_VALUES } from '@vy/types';

export function formatDueDate(dueDate: number | null | undefined): string | null {
  if (dueDate === undefined || dueDate === null) return null;
  if (dueDate === INVOICE_DUE_DATE_VALUES.EOM) return 'Net EoM';
  return `Net ${dueDate}`;
}
